export const events = {
  preferences: {
    updateNotifier: 'Notification setting updated',
    updateCategory: 'Notification category updated',
    updateScope: 'Notification scope updated',
  },

  notifications: {
    goToNotification: 'Notifications Tab Opened',

    viewNotifications: 'View notifications sidepanel',
    viewEmptyNotifications: 'View empty notifications sidepanel',
    loadMoreNotifications: 'Load more notifications',
  },

  requests: {
    goToRequest: 'Go to pending task',
    requestDisplayed: 'Request Displayed',
    quickActionTriggered: 'Quick action triggered',
    goToNotificationLink: 'Go to notification link',
  },

  opened: 'Inbox Opened',
}
